<template>
  <div class="content">
    <el-tabs v-model="activeName">
      <el-tab-pane label="收款统计" name="first">
        <PayAccountEchart></PayAccountEchart>
      </el-tab-pane>
      <el-tab-pane label="收款明细" name="second">
        <PayAccountList ></PayAccountList>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import PayAccountList from "./PayAccountList.vue";
import PayAccountEchart from "./PayAccountEchart.vue";
export default {
  name: "payAccountInfo",
  data() {
    return {
      activeName: "first",
    };
  },
  components: {
    PayAccountList,
    PayAccountEchart
  },
  methods: {
  },
  created() {
  },
};
</script>